<script setup lang="ts">
import { enableDragDropTouch } from '@/classes/DragAndDropMobile';
import { useAnalyticsUserPropertiesSync } from '@/composables/analytics/useAnalyticsUserPropertiesSync';
import { useAnalyticsConsentSync } from '@/composables/analytics/useAnalyticsConsentSync';
import CookieConsentBanner from './core/cookie-consent/CookieConsentBanner.vue';
import DialogContainer from './core/dialogsystem/DialogContainer.vue';

enableDragDropTouch(document, document, {
  allowDragScroll: true,
  isPressHoldMode: true,
  pressHoldDelayMS: 500,
  dragThresholdPixels: 10,
});

useAnalyticsConsentSync();
useAnalyticsUserPropertiesSync();
</script>

<template>
  <RouterView />
  <DialogContainer />
  <CookieConsentBanner />
</template>
